/* eslint-disable no-loop-func */
import React, { useEffect, useRef, useState } from "react";
import { toast } from "../../components/ui/use-toast";
import * as XLSX from "xlsx";
import cellEditFactory from "react-bootstrap-table2-editor";
import { Type } from "react-bootstrap-table2-editor";
import { ResponsiveDrawerForm } from "../../components/ResponsiveDrawerForm";
import Spin from "../../components/Spin";
import {
  API,
  fileUpload,
  get,
  TableClasses,
  TableWrapClasses,
  TDClasses,
  THClasses,
  TRClasses,
} from "../../config";
import BootstrapTable from "react-bootstrap-table-next";
import { Button } from "../../components/ui/button";
import { Download, FileSpreadsheet } from "lucide-react";
import FileUpload from "../../components/FileUpload";
// import XeroImport from "../../components/XeroImport";
import { AnimatedTooltip } from "../../components/AnimatedTooltip";

const UploadChartOfAccount = ({
  accountTypesList,
  fetchAccountData,
  trustId,
  ButtonName,
  setLoading,
}) => {
  const [showImport, setShowImport] = useState(false);
  const [files, setFiles] = useState([]);
  const [showExcelModal, setShowExcelModal] = useState(false);
  const [excelAccountData, setExcelAccountData] = useState();
  const [isImportLoading, setIsImportLoading] = useState(false);
  // const builderId = localStorage.getItem("builderId")
  //   ? localStorage.getItem("builderId")
  //   : "";

  let accountingList = accountTypesList
    // eslint-disable-next-line array-callback-return
    ?.map((item) => {
      const { name: label, id, ...rest } = item;
      item.value = item.name;
      if (item.name === "Expenses" || item.name === "Revenue") {
        return { label, id, ...rest, ...item };
      }
    })
    ?.filter((data) => data !== undefined);

  accountingList.unshift({ label: "Select Account" });

  const typeList = [
    { label: "Select Type", value: "Select Type" },
    { label: "Debit", value: "Debit", excelData: "d", base_type: 0 },
    { label: "Credit", value: "Credit", excelData: "c", base_type: 1 },
  ];

  const taxList = [
    { label: "Select Tax", value: "Select Tax" },
    { label: "GST on Income", value: "GST on Income", tax_type: 1 },
    { label: "GST Free Expenses", value: "GST Free Expenses", tax_type: 0 },
    { label: "GST on Expenses", value: "GST on Expenses", tax_type: 2 },
    { label: "BAS Excluded", value: "BAS Excluded", tax_type: 3 },
  ];

  const handleDownload = async () => {
    try {
      setLoading(true);
      const { data } = await get(API.DOWNLOAD_ACCOUNT_TEMPLATE);
      const export_report_path = data?.data?.file;
      if (export_report_path) {
        var a = document.createElement("a");
        a.href = export_report_path;
        var file = export_report_path.split("/");
        a.setAttribute("target", "_blank");
        a.setAttribute(
          "download",
          file[file.length - 1] || "chart-of-account.xls"
        );
        document.body.appendChild(a);
        a.click();
        a.remove();
        setLoading(false);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  const handleImportModal = async () => {
    setShowImport(!showImport);
  };

  const handleExcelClose = () => {
    setExcelSelectedRow([]);
    setExcelNotSelectedRow([]);
    setShowExcelModal(false);
    setShowImport(false);
    setIsImportLoading(false);
    setFiles([]);
  };

  const handleImportClose = () => {
    setShowImport(false);
    setIsImportLoading(false);
    setFiles([]);
  };

  const handleClose = () => {
    setFiles([]);
  };

  const ExcelAccountColumns = [
    {
      dataField: "account",
      text: "Account",
      editCellClasses: "edit-cell-excel-class",
      editor: {
        type: Type.SELECT,
        options: accountingList,
      },
      classes: (cell) => {
        if (String(cell)?.length === 0) {
          return `${TDClasses} text-red-500 border-red-500 border-y border-r-inherit`;
        } else if (String(cell) === "Select Account") {
          return `${TDClasses} text-red-500`;
        }
        return TDClasses;
      },
      headerClasses: THClasses,
    },
    {
      dataField: "classification",
      text: "Classification",
      editCellClasses: "edit-cell-excel-class",
      classes: (cell) => {
        if (String(cell)?.length === 0) {
          return `${TDClasses} text-red-500 border-red-500 border-y border-r-inherit`;
        }
        return TDClasses;
      },
      headerClasses: THClasses,
      validator: (newValue) => {
        if (String(newValue)?.length === 0) {
          return {
            valid: false,
            message: "Please enter classification",
          };
        }
        return true;
      },
    },
    {
      dataField: "code",
      text: "Code",
      editCellClasses: "edit-cell-excel-class",
      validator: (newValue) => {
        if (newValue) {
          if (String(newValue)?.length > 12) {
            return {
              valid: false,
              message: "Please enter a valid code",
            };
          }
        }
        if (String(newValue)?.length === 0) {
          return {
            valid: false,
            message: "Please enter a valid code",
          };
        }
        if (!String(newValue)?.match(/^[\d]*$/)) {
          return {
            valid: false,
            message: "Please enter a valid code",
          };
        }
        return true;
      },
      classes: (cell) => {
        if (cell) {
          if (String(cell)?.length > 12) {
            return `${TDClasses} text-red-500`;
          }
        }
        if (String(cell)?.length === 0) {
          return `${TDClasses} text-red-500 border-red-500 border-y border-r-inherit`;
        }
        return TDClasses;
      },
      headerClasses: THClasses,
    },
    {
      dataField: "sub_code",
      text: "Subcode",
      editCellClasses: "edit-cell-excel-class",
      validator: (newValue) => {
        if (newValue) {
          if (!String(newValue)?.match(/^[\d]*$/)) {
            return {
              valid: false,
              message: "Please enter a valid subCode",
            };
          }
          if (String(newValue)?.length > 4) {
            return {
              valid: false,
              message: "Please enter a valid subCode",
            };
          }
        }
      },
      classes: (cell) => {
        if (cell) {
          if (String(cell)?.length > 4) {
            return `${TDClasses} text-red-500`;
          }
        }
        return TDClasses;
      },
      headerClasses: THClasses,
    },
    {
      dataField: "description",
      text: "Description",
      editCellClasses: "edit-cell-excel-class",
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "type",
      text: "Credit/Debit",
      editCellClasses: "edit-cell-excel-class",
      editor: {
        type: Type.SELECT,
        options: typeList,
      },
      classes: (cell) => {
        if (String(cell)?.length === 0) {
          return `${TDClasses} text-red-500 border-red-500 border-y border-r-inherit`;
        } else if (String(cell) === "Select Type") {
          return `${TDClasses} text-red-500 `;
        }
        return TDClasses;
      },
      headerClasses: THClasses,
    },
    {
      dataField: "tax",
      text: "Tax",
      editCellClasses: "edit-cell-excel-class",
      editor: {
        type: Type.SELECT,
        options: taxList,
      },
      classes: (cell) => {
        if (String(cell)?.length === 0) {
          return `${TDClasses} text-red-500 border-red-500 border-y border-r-inherit`;
        } else if (String(cell) === "Select Tax") {
          return `${TDClasses} text-red-500`;
        }
        return TDClasses;
      },
      headerClasses: THClasses,
    },
  ];

  const [excelSelectedRow, setExcelSelectedRow] = useState([]);
  const [excelNotSelectedRow, setExcelNotSelectedRow] = useState([]);

  let singleExcelSelectedRows = [];
  let allExcelSelectedRows = [];

  const excelSelectRow = {
    mode: "checkbox",
    clickToSelect: false,
    classes: "selection-row",
    nonSelectable: excelNotSelectedRow,
    selected: excelSelectedRow,
    nonSelectableClasses: "not-selected-class",
    onSelect: (row, isSelect, rowIndex, e) => {
      singleExcelSelectedRows = [...excelSelectedRow];
      if (isSelect) {
        singleExcelSelectedRows = [...excelSelectedRow, row?.key];
      } else {
        singleExcelSelectedRows.splice(excelSelectedRow.indexOf(row?.key), 1);
      }
      setExcelSelectedRow(singleExcelSelectedRows);
    },
    onSelectAll: (isSelect, rows, e) => {
      if (isSelect) {
        for (let i = 0; i < rows.length; i++) {
          if (excelSelectedRow.includes(rows[i].key)) {
          } else {
            allExcelSelectedRows.push(rows[i].key);
          }
        }
      } else {
        for (let i = 0; i < rows.length; i++) {
          if (excelSelectedRow.includes(rows[i].key)) {
            excelSelectedRow.splice(excelSelectedRow.indexOf(rows[i].key), 1);
          }
        }
      }
      setExcelSelectedRow([...excelSelectedRow, ...allExcelSelectedRows]);
    },
  };

  const excelRef = useRef();

  function padWithLeadingZeros(num, totalLength) {
    return String(num).padStart(totalLength, "0");
  }

  const ExcelReader = () => {
    let f = files[0];
    const reader = new FileReader();
    let data = null;
    reader.onload = async (evt) => {
      // evt = on_file_select event
      /* Parse data */
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { type: "binary" });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      data = await XLSX.utils.sheet_to_json(ws, { header: 1 });
      /* Update state */
      let selectItem = [];
      let selectNotItem = [];
      const businessExcelGenerator = (quantity) => {
        const items = [];
        if (
          data[0][0] !== "Account" ||
          data[0][1] !== "Classification" ||
          data[0][2] !== "Code" ||
          data[0][3] !== "Subcode" ||
          data[0][4] !== "Description" ||
          data[0][5] !== "Credit/Debit" ||
          data[0][6] !== "Tax"
        ) {
          setShowExcelModal(false);
          setFiles([]);
          setIsImportLoading(false);

          toast({
            variant: "destructive",
            description:
              "Sorry, File is not in the given format, please download the latest format again",
            duration: 3000,
          });
        } else {
          for (let i = 1; i < quantity; i++) {
            let code = null;
            if (
              String(data[i][2])?.length < 4 &&
              String(data[i][2])?.length !== 0
            ) {
              if (String(data[i][2])?.match(/^[\d]*$/)) {
                code = padWithLeadingZeros(String(data[i][2]), 4);
              }
            }
            let subCode = null;
            if (
              String(data[i][3])?.length < 2 &&
              String(data[i][3])?.length !== 0
            ) {
              if (String(data[i][3])?.match(/^[\d]*$/)) {
                subCode = padWithLeadingZeros(String(data[i][3]), 2);
              }
            }

            if (data[i].length > 0) {
              if (code === null) {
                if (data[i][2]) {
                  if (String(data[i][2])?.length > 7) {
                    selectNotItem.push(i);
                  } else if (String(data[i][2])?.length === 7) {
                    selectItem.push(i);
                  } else if (String(data[i][2])?.length < 7) {
                    selectItem.push(i);
                  } else {
                    selectItem.push(i);
                  }
                } else {
                  selectNotItem.push(i);
                }
              } else {
                if (
                  !code ||
                  !accountingList.find((item) => item?.label === data[i][0]) ||
                  !typeList.find(
                    (item) =>
                      item.excelData === String(data[i][5]).toLowerCase()
                  ) ||
                  !taxList.find((item) => item.value === data[i][6]) ||
                  data[i][1]?.length === 0 ||
                  !data[i][1]
                ) {
                  selectNotItem.push(i);
                } else {
                  selectItem.push(i);
                }
              }

              items.push({
                key: i,
                row_key: i,
                // eslint-disable-next-line
                account: data[i][0]
                  ? accountingList.find((item) => item?.label === data[i][0])
                    ? data[i][0]
                    : "Select Account"
                  : "",
                classification: data[i][1] ? data[i][1] : "",
                code: code ? code : data[i][2] ? data[i][2] : "",
                sub_code: subCode ? subCode : data[i][3] ? data[i][3] : "",
                description: data[i][4] ? data[i][4] : "",
                // eslint-disable-next-line
                type: data[i][5]
                  ? typeList.find(
                      (item) =>
                        item.excelData === String(data[i][5]).toLowerCase()
                    )
                    ? typeList.find(
                        (item) =>
                          item.excelData === String(data[i][5]).toLowerCase()
                      ).label
                    : "Select Type"
                  : "",
                // eslint-disable-next-line
                tax: data[i][6]
                  ? taxList.find((item) => item.value === data[i][6])
                    ? data[i][6]
                    : "Select Tax"
                  : "",
              });
            }
          }
        }

        return items;
      };
      setExcelSelectedRow(selectItem);
      setExcelNotSelectedRow(selectNotItem);
      setExcelAccountData(businessExcelGenerator(data?.length));
    };
    reader.readAsBinaryString(f);
  };

  useEffect(() => {
    showExcelModal && ExcelReader();
    // eslint-disable-next-line
  }, [showExcelModal]);

  const handleExcelModal = () => {
    setShowExcelModal(true);
  };

  const handleUpload = async () => {
    if (excelSelectedRow.length > 1000) {
      toast({
        description: "Maximum limit to import chart of accounts is 1000",
        duration: 3000,
      });
    } else {
      if (files) {
        setShowExcelModal(true);
        const formData = new FormData();

        formData.append("trust_id", trustId);

        let arr = Array.from(new Set(excelSelectedRow));
        for (let i = 0; i < arr.length; i++) {
          let row = excelAccountData.find((item) => item.key === arr[i]);
          if (row.account) {
            if (row.account === "Select Account") {
              row.account = "";
              row.account_id = "";
            } else {
              row.account_id = accountingList?.find(
                (item) => item?.label === row?.account
              )?.id;
            }
          }
          if (row.type) {
            if (row.type === "Select Type") {
              row.type = "";
            } else {
              row.type = typeList?.find(
                (item) => item?.label === row?.type
              )?.base_type;
            }
          }
          if (row.tax) {
            if (row.tax === "Select Tax") {
              row.tax = "";
            } else {
              row.tax = taxList?.find(
                (item) => item?.label === row?.tax
              )?.tax_type;
            }
          }
          if (row.sub_code === "") {
            row.sub_code = "";
          }
          if (row.description === "") {
            row.description = "";
          }
          // formData.append(`accounts[${i}]`, JSON.stringify(row));
          Object.keys(row).forEach((key) => {
            if (key === "classification") {
              formData.append(`accounts[${i}][name]`, row[key]);
            } else {
              formData.append(`accounts[${i}][${key}]`, row[key]);
            }
          });
        }

        const config = { headers: { "Content-Type": "multipart/form-data" } };
        try {
          setIsImportLoading(true);
          const { data } = await fileUpload(
            `${API.IMPORT_ACCOUNT}`,
            formData,
            config
          );
          setIsImportLoading(false);
          if (data?.data?.file) {
            const export_report_path = data?.data?.file;
            if (export_report_path) {
              let a = document.createElement("a");
              a.href = export_report_path;
              let file = export_report_path.split("/");
              a.setAttribute(
                "download",
                file[file.length - 1] || "error-chart-of-accounts.xls"
              );
              a.setAttribute("target", "_blank");
              document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
              a.click();
              a.remove();
            }
          }
          if (data) {
            setExcelSelectedRow([]);
            setExcelNotSelectedRow([]);
            handleExcelClose();
            fetchAccountData();
            handleImportClose();
          }
          return data?.data;
        } catch (error) {
          fetchAccountData();
          setIsImportLoading(false);
        }
      }
    }
  };

  const handleExcelTableChange = async (
    type,
    { data, cellEdit: { rowId, dataField, newValue } }
  ) => {
    const getWithPromiseAll = async () => {
      let temp = await Promise.all(
        data.map(async (row) => {
          if (row?.key === rowId) {
            const newRow = { ...row };
            let code = null;
            if (dataField !== "description" && dataField !== "sub_code") {
              if (
                (row?.code || (dataField === "code" && newValue)) &&
                (row?.account !== "Select Account" ||
                  (dataField === "account" && newValue !== "Select Account")) &&
                (row?.type !== "Select Type" ||
                  (dataField === "type" && newValue !== "Select Type")) &&
                (row?.tax !== "Select Tax" ||
                  (dataField === "tax" && newValue !== "Select Tax")) &&
                (row?.classification?.length !== 0 ||
                  (dataField === "classification" && newValue?.length !== 0))
              ) {
                if (
                  ((dataField === "account" && newValue === "Select Account") ||
                    (dataField === "type" && newValue === "Select Type") ||
                    (dataField === "tax" && newValue === "Select Tax")) &&
                  dataField !== "code"
                ) {
                  let y = excelSelectedRow;
                  y.splice(y.indexOf(row?.key), 1);
                  if (String(row?.code)?.length > 12) {
                    setExcelSelectedRow(y);
                    excelNotSelectedRow.push(row?.key);
                  } else if (String(row?.code)?.length === 7) {
                    if (
                      String(row?.code)?.match("/") &&
                      String(row?.code)?.match("/")?.index !== 2
                    ) {
                      setExcelSelectedRow(y);
                      excelNotSelectedRow.push(row?.key);
                    } else if (
                      String(row?.code)?.match("-") &&
                      String(row?.code)?.match("-")?.index !== 2
                    ) {
                      setExcelSelectedRow(y);
                      excelNotSelectedRow.push(row?.key);
                    }
                  } else if (String(row?.code)?.length < 7) {
                    if (
                      String(row?.code)?.match("/") &&
                      String(row?.code)?.match("/")?.index !== 1
                    ) {
                      setExcelSelectedRow(y);
                      excelNotSelectedRow.push(row?.key);
                    } else if (
                      String(row?.code)?.match("-") &&
                      String(row?.code)?.match("-")?.index !== 1
                    ) {
                      setExcelSelectedRow(y);
                      excelNotSelectedRow.push(row?.key);
                    }
                  } else {
                    setExcelSelectedRow(y);
                    excelNotSelectedRow.push(row?.key);
                  }
                } else {
                  excelNotSelectedRow.splice(
                    excelNotSelectedRow.indexOf(row?.key),
                    1
                  );
                  excelSelectedRow.push(row?.key);
                }
              }
            }
            if (dataField === "code") {
              if (String(newValue)?.length < 4) {
                if (
                  !String(newValue)?.match("/") &&
                  !String(newValue)?.match("-")
                ) {
                  code = padWithLeadingZeros(String(newValue), 4);
                }
                if (
                  String(newValue)?.match("/") &&
                  (String(newValue)?.match("/")?.index === 1 ||
                    String(newValue)?.match("/")?.index === 2)
                ) {
                  let temp = String(newValue).split("/");
                  let firstNumber = padWithLeadingZeros(String(temp[0]), 2);
                  let secondNumber = padWithLeadingZeros(String(temp[1]), 4);
                  code = `${firstNumber}/${secondNumber}`;
                }
                if (
                  String(newValue)?.match("-") &&
                  (String(newValue)?.match("-")?.index === 1 ||
                    String(newValue)?.match("-")?.index === 2)
                ) {
                  let temp = String(newValue).split("-");
                  let firstNumber = padWithLeadingZeros(String(temp[0]), 2);
                  let secondNumber = padWithLeadingZeros(String(temp[1]), 4);
                  code = `${firstNumber}-${secondNumber}`;
                }
              } else if (String(newValue)?.length < 8) {
                if (
                  String(newValue)?.match("/") &&
                  (String(newValue)?.match("/")?.index === 1 ||
                    String(newValue)?.match("/")?.index === 2)
                ) {
                  let temp = String(newValue).split("/");
                  let firstNumber = padWithLeadingZeros(String(temp[0]), 2);
                  let secondNumber = padWithLeadingZeros(String(temp[1]), 4);
                  code = `${firstNumber}/${secondNumber}`;
                }
                if (
                  String(newValue)?.match("-") &&
                  (String(newValue)?.match("-")?.index === 1 ||
                    String(newValue)?.match("-")?.index === 2)
                ) {
                  let temp = String(newValue).split("-");
                  let firstNumber = padWithLeadingZeros(String(temp[0]), 2);
                  let secondNumber = padWithLeadingZeros(String(temp[1]), 4);
                  code = `${firstNumber}-${secondNumber}`;
                }
              }
              newRow[dataField] = code ? code : newValue;
            } else if (dataField === "sub_code") {
              let subCode = null;
              if (String(newValue)?.length < 2) {
                if (String(newValue)?.match(/^[\d]*$/)) {
                  subCode = String(padWithLeadingZeros(String(newValue), 2));
                }
                if (String(newValue)?.length === 0) {
                  subCode = null;
                }
              }
              newRow[dataField] = subCode ? subCode : newValue;
            } else if (dataField === "account") {
              let accountValue = accountingList?.find(
                (item) => item?.value === newValue
              );
              newRow[dataField] = accountValue
                ? accountValue?.label
                : "Select Account";
            } else {
              newRow[dataField] = newValue;
            }

            return newRow;
          }
          return row;
        })
      );
      return temp;
    };
    const result = await getWithPromiseAll();
    setExcelAccountData(result);
  };
  return (
    <>
      <div className="flex bg-webPrimary rounded-md">
        <AnimatedTooltip title={"Import Chart of Account"}>
          <Button
            onClick={handleImportModal}
            className="bg-transparent flex items-center gap-1 px-2"
          >
            <FileSpreadsheet size={18} />
            {ButtonName}
          </Button>
        </AnimatedTooltip>
        <AnimatedTooltip title={"Download Template"}>
          <Button
            onClick={() => handleDownload()}
            className="bg-transparent border-l border-white dark:border-black rounded-none px-2 rounded-se-md rounded-ee-md"
          >
            <Download size={18} />
          </Button>
        </AnimatedTooltip>
      </div>
      <ResponsiveDrawerForm
        description={""}
        title={"Import Chart of Accounts"}
        handleOpen={() => {}}
        handleClose={() => {
          handleClose();
        }}
        write={true}
        className={"sm:max-w-1/2"}
        open={showImport}
        buttonClassName={""}
        setOpen={setShowImport}
        mobileCancelHidden={true}
      >
        <>
          <FileUpload
            files={files}
            setFiles={setFiles}
            accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/csv"
          />
          {/* <XeroImport
            builderId={builderId}
            module={"chart of accounts"}
            fetchData={fetchAccountData}
            trustId={trustId}
            handleImportClose={handleImportClose}
            api={API.XERO_COA}
          /> */}

          <div className="modal-footer pt-4 border-t mt-4 flex items-center justify-center">
            <Button
              type="submit"
              onClick={(e) => {
                handleExcelModal();
              }}
              disabled={files?.length === 0}
            >
              Upload
            </Button>
            <Button
              className="reset ml-3"
              data-dismiss="modal"
              aria-label="Close"
              onClick={(e) => {
                handleImportClose();
              }}
              variant="secondary"
            >
              Cancel
            </Button>
          </div>
        </>
      </ResponsiveDrawerForm>
      <ResponsiveDrawerForm
        description={""}
        title={"Upload Excel"}
        handleOpen={() => {}}
        handleClose={() => {}}
        className={"max:min-w-screen"}
        open={showExcelModal}
        buttonClassName={""}
        setOpen={setShowExcelModal}
        write={true}
      >
        <div className="overflow-y-auto overflow-x-hidden max-h-[78vh] md:p-0 p-4">
          {isImportLoading && <Spin full expand={true} fullscreen={true}/>}
          <div className="table-body-class">
            <BootstrapTable
              keyField="key"
              selectRow={excelSelectRow}
              ref={excelRef}
              remote={{ cellEdit: true }}
              data={excelAccountData ? excelAccountData : []}
              columns={ExcelAccountColumns}
              noDataIndication="No Data Found"
              cellEdit={cellEditFactory({
                mode: "click",
                blurToSave: true,
                timeToCloseMessage: 30000,
              })}
              onTableChange={handleExcelTableChange}
              rowClasses={TRClasses}
              classes={TableClasses}
              wrapperClasses={TableWrapClasses}
            />
          </div>
          <div className="pt-4 border-t mt-4 flex items-center justify-between">
            <div>Selected Records: {excelSelectedRow?.length}</div>
            <Button
              onClick={handleUpload}
              data-toggle="modal"
              data-target="#business"
              disabled={excelSelectedRow.length === 0 ? true : false}
            >
              Import
            </Button>
          </div>
        </div>
      </ResponsiveDrawerForm>
    </>
  );
};

export default UploadChartOfAccount;
